import type { NavItem } from '../../lib/types/navigation';
import type { UserRole } from '../../lib/types/shared';
import { 
  Home, 
  Phone, 
  User, 
  HelpCircle, 
  Users, 
  BarChart2, 
  Settings 
} from 'lucide-react';

// Centralized navigation configuration
export const NAVIGATION_CONFIG: Record<UserRole, NavItem[]> = {
  'guest': [
    {
      id: 'login',
      label: 'Login',
      icon: User,
      path: '/login'
    }
  ],
  'agent': [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/dashboard'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile'
    },
    {
      id: 'new-sale',
      label: 'New Sale',
      icon: Phone,
      path: '/sales/new'
    }
  ],
  'upline': [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/dashboard'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile'
    },
    {
      id: 'team-performance',
      label: 'Team Performance',
      icon: BarChart2,
      path: '/team/performance'
    }
  ],
  'manager': [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/dashboard'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile'
    },
    {
      id: 'team-performance',
      label: 'Team Performance',
      icon: BarChart2,
      path: '/team/performance'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: BarChart2,
      path: '/reports'
    }
  ],
  'admin': [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/dashboard'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile'
    },
    {
      id: 'agent-management',
      label: 'Agent Management',
      icon: Users,
      path: '/agency/agents'
    },
    {
      id: 'agency-settings',
      label: 'Agency Settings',
      icon: Settings,
      path: '/agency/settings'
    }
  ],
  'agency-owner': [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/dashboard'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile'
    },
    {
      id: 'agent-management',
      label: 'Agent Management',
      icon: Users,
      path: '/agency/agents'
    }
  ],
  'imo': [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/dashboard'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: BarChart2,
      path: '/reports'
    }
  ],
  'super-admin': [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/dashboard'
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile'
    },
    {
      id: 'agent-management',
      label: 'Agent Management',
      icon: Users,
      path: '/agency/agents'
    },
    {
      id: 'agency-settings',
      label: 'Agency Settings',
      icon: Settings,
      path: '/agency/settings'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: BarChart2,
      path: '/reports'
    }
  ]
};
